import { Befehl } from '../models'
import { hasBefehlGenericEmptyFields } from './generic'
import { findAuftrag, hasFieldContent } from './helpers'

export function hasBefehl33EmptyFields(befehl: Befehl): boolean {
  if (!befehl.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag3310 = findAuftrag(befehl, '33.10')
  if (auftrag3310) {
    const has3311 = hasFieldContent(auftrag3310, '33.11', 'lzbBk')
    const has3312 = hasFieldContent(auftrag3310, '33.12', 'etcsBk')
    if (!has3311 && !has3312) {
      return true
    }
  }

  return false
}
